import type { SwitchProps } from './Switch';
import Switch from './Switch';

export type { SwitchProps };
export default Switch;
